import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProducrtByAllMutation } from "../../../../../store/user/userProductApiSlice";

export const DownloadDashcam = () => {
    const navigate = useNavigate()
    const [getProductByAll] = useGetProducrtByAllMutation()
    const [data, setData] = useState([])
    const getList = async() => {
        const param = {channelType: '', resolutionType : '', featuresType : '', page : 1, size : 99}
        const result : any = await getProductByAll(param)
        if(result.data.Result==='true') setData(result.data.List)
    }
    let reArr: any[] = [...data] || [];
    const productIdToMove = ['38', '41', '40', '42', '43'];
    let itemsToMove: any[] = [];
    reArr = reArr.filter((x: any) => {
        if (productIdToMove.includes(x?.productId)) {
            itemsToMove.push(x);
            return false;
        }
        return true;
    });
    const itemM = itemsToMove.find(x => x?.productId === '38');
    const itemM2 = itemsToMove.find(x => x?.productId === '41');
    const itemM3 = itemsToMove.find(x => x?.productId === '40');
    const itemM4 = itemsToMove.find(x => x?.productId === '42');
    const itemM5 = itemsToMove.find(x => x?.productId === '43');
    if (itemM5 && itemM4 && itemM3 && itemM2 && itemM) {
        reArr = [itemM5, itemM4, itemM3, itemM2, itemM, ...reArr];
    }
    useEffect(()=>{getList()}, [])

    return(
        <>
        <div className="contentBox">
            <h2>
                Download
                <span>FineVu Dashcam</span>
            </h2>
            <p>Firmware · Manual · Speed Cam Data</p>
            <ul>
                {reArr && reArr?.map((list:any)=>(
                <li key={list?.productId} onClick={()=>navigate(`/support/download/dashcam/${list?.productId}`)}>
                    <div className="thumbBox">
                        <img src={list?.productWhiteImageFile} alt="GX4K"/>
                    </div>
                    <span>{list?.productName}</span>
                </li>
                ))}
            </ul>
        </div>
        </>
    )
}
